import { registerMutation } from 'data-fetching-client';
import setFormPermissions from 'asset-actions-lib-forms/api/permissions/setFormPermissions';
export const SET_FORM_PERMISSIONS_FIELD_NAME = 'setFormPermissions';
export const SET_FORM_PERMISSIONS = registerMutation({
  fieldName: SET_FORM_PERMISSIONS_FIELD_NAME,
  args: ['formGuids', 'permissions'],
  fetcher: ({
    formGuids,
    permissions
  }) => setFormPermissions(formGuids, permissions)
});